import Vue from 'vue'
import Router from 'vue-router'

import GestaoCadastros from '../pages/GestaoCadastros/Index.vue'
import BuscaAtivaCadastro from '../pages/GestaoCadastros/BuscaAtivaCadastro/Index.vue'
import CidadaosDuplicados from '../pages/GestaoCadastros/CidadaosDuplicados/Index.vue'
import CidadaosSemAcs from '../pages/GestaoCadastros/CidadaosSemAcs'
import CadastrosSemCpf from '../pages/GestaoCadastros/CadastrosSemCpf/Index.vue'
import CidadaosCnsInvalidos from '../pages/GestaoCadastros/CidadaosCnsInvalidos/Index'
import CidadaosDesatualizados from '../pages/GestaoCadastros/CidadaosDesatualizados/Index'

import CalculadoraDePessoas from '../pages/GestaoCadastros/CalculadoraDePessoas/Index'
import Obitos from '@/pages/GestaoCadastros/Obitos/Index'
import ObitosPorEquipeAcs from '@/pages/GestaoCadastros/Obitos/PorEquipeAcs'
import ObitosPorProfissional from '@/pages/GestaoCadastros/Obitos/PorProfissional'
import MudancaTerritorio from '@/pages/GestaoCadastros/MudancaTerritorio/Index'
import MudancaTerritorioPorEquipeAcs from '@/pages/GestaoCadastros/MudancaTerritorio/PorEquipeAcs'
import MudancaTerritorioProfissional from '@/pages/GestaoCadastros/MudancaTerritorio/PorProfissional'

function authMiddlewareCidadaoPainel(to, from, next) {
  // só aplica se a rota exigir autenticação
  if (!to.matched.some((r) => r.meta.requiresAuth)) {
    return next()
  }

  // tenta recuperar o objeto salvo no sessionStorage
  const vuex = JSON.parse(sessionStorage.getItem('vuex') || '{}')
  const token = vuex?.accessToken || null
  if (!token) {
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }

  const parceiro = vuex?.infoMunicipio?.parceiro
  if (parceiro == null) {
    return next()
  }

  if (parceiro != null && vuex?.id_funcao == '2') {
    return next()
  } else {
    return next({
      path: '/pagina-indisponivel',
    })
  }
}

export default [
  {
    path: '/gestao-cadastros',
    component: GestaoCadastros,
  },
  {
    path: '/cidadao/painel',
    name: 'cidadao-painel',
    component: () => import('@/pages/GestaoCadastros/CidadaoPainel/Index.vue'),
    // meta: { requiresAuth: true },
    // beforeEnter: authMiddlewareCidadaoPainel,
  },
  {
    path: '/busca-ativa-cadastro',
    component: BuscaAtivaCadastro,
  },
  {
    path: '/cidadaos-duplicados',
    component: () =>
      import('@/pages/GestaoCadastros/CidadaosDuplicados/Template.vue'),
    children: [
      {
        path: '/cidadaos-duplicados',
        component: CidadaosDuplicados,
      },
    ],
  },
  {
    path: '/cidadaos-sem-acs',
    component: CidadaosSemAcs,
  },
  {
    path: '/cadastros-sem-cpf',
    component: () =>
      import('@/pages/GestaoCadastros/CadastrosSemCpf/Template.vue'),
    children: [
      {
        path: '/cadastros-sem-cpf',
        component: CadastrosSemCpf,
      },
    ],
  },
  {
    path: '/cidadaos-cns-invalidos',
    component: CidadaosCnsInvalidos,
  },
  {
    path: '/cidadaos-desatualizados',
    component: CidadaosDesatualizados,
  },
  {
    path: '/calculadora-de-pessoas',
    component: () =>
      import('@/pages/GestaoCadastros/CalculadoraDePessoas/Template.vue'),
    children: [
      {
        path: '/calculadora-de-pessoas',
        component: CalculadoraDePessoas,
      },
    ],
  },
  {
    path: '/obitos',
    component: () => import('@/pages/GestaoCadastros/Obitos/Template.vue'),
    children: [
      {
        path: '/obitos',
        component: Obitos,
      },
      {
        path: '/obitos/profissional',
        component: ObitosPorProfissional,
      },
      {
        path: '/obitos/equipe/acs',
        component: ObitosPorEquipeAcs,
      },
    ],
  },
  {
    path: '/mudanca_territorio',
    component: () =>
      import('@/pages/GestaoCadastros/MudancaTerritorio/Template.vue'),
    children: [
      {
        path: '/mudanca_territorio/',
        component: MudancaTerritorio,
      },
      {
        path: '/mudanca_territorio/profissional',
        component: MudancaTerritorioProfissional,
      },
      {
        path: '/mudanca_territorio/equipe/acs',
        component: MudancaTerritorioPorEquipeAcs,
      },
    ],
  },
]
